import { render, staticRenderFns } from "./CandidateActionVerbs.vue?vue&type=template&id=125811d2&"
import script from "./CandidateActionVerbs.vue?vue&type=script&lang=js&"
export * from "./CandidateActionVerbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports